<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Book-Title--Front-Matter-">Porky</p>
<p class="ORIM-Author-Name--Front-Matter-"> Deborah Moggach</p>
<p class="ORIM-Author-Name--Front-Matter-"><img src="images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Porky25.vue?ba00b6ae